import { BuildConfig } from '@tdp';
import { ITdpClientHost } from '@tdp/common/host';

import {
  AuthConfigSchema,
  composeAuth,
  WebHostAuthDependencies,
} from './authClient';
import { WebThemeReader } from './themeReader';

type WebHostDependencies = Omit<WebHostAuthDependencies, 'config'> & {
  config: BuildConfig;
};

export async function createHost(
  deps: WebHostDependencies
): Promise<ITdpClientHost> {
  const { config, ...authDeps } = deps;
  const authConfig = AuthConfigSchema.parse(config.auth);
  const { authClient } = await composeAuth({
    config: authConfig,
    ...authDeps,
  });
  const themeReader = new WebThemeReader({ window });

  return {
    auth: authClient,
    themeReader,
  };
}
